<template>
    <li class="list-grid" :class="{ 'list-grid-2r': twoRow }" >
        <h3 class="item-title title-type-simple">{{ subTitle }}</h3>
        <slot />
    </li>
</template>

<script>
export default {
    props: ["subTitle", "twoRow"]
}
</script>

<style src="@/assets/css/overview.css" scoped> </style>